import React from "react";
import type { FC, PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginSliceValue } from "../redux/reducers/loginSlice";

import Header from "./Header";
import Sidebar, { SideProps } from "./SideBar";
import "../styles/Content.css";

type ContentProps = PropsWithChildren<{
  currentMenu: SideProps["currentMenu"];
  headerTitle?: string;
  addBtn?: boolean;
  addBtnTitle?: string;
  addBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  addBtnIcon?: string;
  searchBox?: boolean;
  searchPlaceholder?: string;
  handleSearchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  totalReult?: string;
  dropdown?: boolean;
  dropdownValue?: string;
  dropdownChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  dropdownOptions?: { value: string; label: string }[];
  dropdown2?: boolean;
  dropdown2Value?: string;
  dropdown2Change?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  dropdown2Options?: { value: string; label: string }[];
  extraBtn?: boolean;
  extraBtnTitle?: string;
  extraBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
  list?: boolean;
  customContentStyle?: React.CSSProperties;
  customContainerStyle?: React.CSSProperties;
  contentClass?: String;
}>;

const Content: FC<ContentProps> = (props) => {
  const navigate = useNavigate();

  const [userRole, setUserRole] = React.useState("");
  const { loading, userDetails } = useSelector(loginSliceValue);

  React.useEffect(() => {
    if (!loading && !userDetails.token) {
      navigate("/login");
    }
  }, [loading, userDetails, navigate]);

  React.useEffect(() => {
    if (userDetails.data?.user.role) {
      setUserRole(userDetails.data?.user.role);
    }
  }, [userDetails]);

  let currentMenu: any = undefined;
  if (props.currentMenu === "rtm-time-logging") {
    currentMenu = "rtm-time-logging";
  } else if (props.currentMenu === "rtm-resource") {
    currentMenu = "rtm-resource";
  } else if (props.currentMenu === "rtm-template") {
    currentMenu = "rtm-template";
  } else if (props.currentMenu === "rtm-plan") {
    currentMenu = "rtm-plan";
    // } else if (props.currentMenu === "dashboard") {
    //   currentMenu = "PatientsDashboard";
  }

  return (
    <main className="container">
      <Sidebar currentMenu={currentMenu} userRole={userRole} />

      <div className="mainContent" style={props.customContainerStyle}>
        <Header
          headerTitle={props.headerTitle}
          addBtn={props.addBtn}
          addBtnTitle={props.addBtnTitle}
          addBtnClick={props.addBtnClick}
          addBtnIcon={props.addBtnIcon}
          searchBox={props.searchBox}
          searchPlaceholder={props.searchPlaceholder}
          handleSearchChange={props.handleSearchChange}
          totalReult={props.totalReult}
          userRole={userRole}
          dropdown={props.dropdown}
          dropdownValue={props.dropdownValue}
          dropdownChange={props.dropdownChange}
          dropdownOptions={props.dropdownOptions}
          dropdown2={props.dropdown2}
          dropdown2Value={props.dropdown2Value}
          dropdown2Change={props.dropdown2Change}
          dropdown2Options={props.dropdown2Options}
          extraBtn={props.extraBtn}
          extraBtnTitle={props.extraBtnTitle}
          extraBtnClick={props.extraBtnClick}
          list={props.list}
          currentMenu={props.currentMenu}
        />
        <div
          className={`content ${props.contentClass}`}
          style={props.customContentStyle}
        >
          {props.children}
        </div>
      </div>
    </main>
  );
};

export default Content;
